/** Кнопка «На весь экран»: под кнопкой отзыва, на десктопе в правой колонке. Только на компьютере (./fullscreen.ts). */
import { addMessages, type MessageBundle } from "../i18n";
import { fullscreenStore, toggleFullscreen } from "./fullscreen";
import { useStore, useT } from "./hooks";
import "./language.css";

const fullscreenMessages: MessageBundle<"fullscreen.on" | "fullscreen.off"> = {
  en: { "fullscreen.on": "Full screen", "fullscreen.off": "Exit full screen" },
  ru: { "fullscreen.on": "На весь экран", "fullscreen.off": "Выйти из полного экрана" },
  uk: { "fullscreen.on": "На весь екран", "fullscreen.off": "Вийти з повного екрана" },
};
addMessages(fullscreenMessages);

export function FullscreenButton() {
  const { mode, on } = useStore(fullscreenStore, (s) => s);
  const t = useT();
  if (!mode) return null;
  const label = t(on ? "fullscreen.off" : "fullscreen.on");
  return (
    <button
      type="button"
      class="fullscreen-button"
      data-testid="fullscreen-button"
      data-on={on ? "1" : "0"}
      aria-pressed={on}
      aria-label={label}
      title={label}
      onClick={() => toggleFullscreen()}
    >
      <svg
        viewBox="0 0 24 24"
        width="20"
        height="20"
        aria-hidden="true"
        fill="none"
        stroke="#fff"
        stroke-width="2.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        {on ? <path d="M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5" /> : <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" />}
      </svg>
    </button>
  );
}
